import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Card } from "reactstrap";
import ReactStars from "react-rating-stars-component";
import { ProfileService } from "../../../../services/ProfileService";
import { isValidEmail } from "../../../../helpers/Utils";
import { JobService } from "../../../../services/JobService";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import timeDifference from "../../../../utilities/timeutitlity";
import SvgRatingImage from "../../../../components/svg/svgratingimage";
import TeamanicsButton from "../../../../../src/buttoncomponent/TeamanicsButton";
import SvgRatingSkillCandidate from "../../../../components/svg/svgratingskillcandidate";
import {
  formattedMobileNumber,
  getPhoneNumberByCountryCode,
  validatePhoneNumber,
} from "../../../../utilities/phonenumberutility";
import TrustedCandidateText from "../../../../components/text/trustedcandidatetext";
import { Stringutility } from "../../../../utilities/stringutility";
import { Constants } from "../../../../constants/constantValues";
import { StorageValues } from "../../../../constants/storageValues";
import { StorageService } from "../../../../services/StorageService";

const RatingScreen = () => {
  const [ispreferedEmail, setPreferedEmail] = useState(false);
  const [ispreferedContactNumber, setPreferedContactNumber] = useState(false);
  const [peerRatingList, setPeerRatingList] = useState([]);
  const [ratingCount, setRatingCount] = useState();
  const [peerratingid, setPeerRatingId] = useState();
  const history = useHistory();

  const [peerContactNumber, setPeerContactNumber] = useState("");
  const [avgrating, setavgrating] = useState("");
  const [showRatings, setShowRatings] = useState(true);
  const [candidateHaveSkills, setCandidateHaveSkills] = useState(false);
  const [inputField, setInputField] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    description: "",
  });
  const [countryCode, setCountryCode] = useState("");
  const [selectionId, setSelectionId] = useState("");
  const [showPersonal, setShowPersonal] = useState(false);
  const [expId, setExpId] = useState("");
  const [experiencesList, setExperiencesList] = useState([]);

  const [showEmployers, setShowEmployers] = useState(false);
  const [workedSameTeam, setWorkedSameTeam] = useState(false);
  const [workedDiffTeams, setWorkedDiffTeams] = useState(false);
  const [youSupervisedPeer, setYouSupervisedPeer] = useState(false);
  const [b2bRelation, setB2bRelation] = useState(false);
  const [customerRelation, setCustomerRelation] = useState(false);
  const [peerSupervisedYou, setPeerSupervisedYou] = useState(false);
  const [mentoringOrTraining, setMentoringOrTraining] = useState(false);
  const [academicRelation, setAcademicRelation] = useState(false);
  const [personalRelation, setPersonalRelation] = useState(false);
  const [peerRewquestEnabled, setpeerRewquestEnabled] = useState(false);

  const [preferredContactType, setPreferredContactType] = useState("");

  const [requestId, setRequestId] = useState("");
  const location = useLocation();

  const [peerMobileNumber, setPeerMoblieNumber] = useState("");
  const [peerMobileNumberCountryCode, setPeerMobileNumberCountryCode] =
    useState("1");

  const updateWorkedSameTeam = () => {
    setWorkedSameTeam(!workedSameTeam);
  };

  const clearDetails = () => {
    setWorkedSameTeam(false);
    setYouSupervisedPeer(false);
    setB2bRelation(false);
    setCustomerRelation(false);
    setPeerSupervisedYou(false);
    setMentoringOrTraining(false);
    setAcademicRelation(false);
    setPersonalRelation(false);
    setpeerRewquestEnabled(false);
    setShowEmployers(false);
  };

  const updateYouSupervisedPeer = () =>
    setYouSupervisedPeer(!youSupervisedPeer);

  const updatePeerSupervisedYou = () =>
    setPeerSupervisedYou(!peerSupervisedYou);

  const updateB2BRelation = () => setB2bRelation(!b2bRelation);

  const updateMentoringOrTraining = () =>
    setMentoringOrTraining(!mentoringOrTraining);

  const updateCustomerRelation = () => setCustomerRelation(!customerRelation);
  const updateAcademicRelation = () => setAcademicRelation(!academicRelation);

  useEffect(() => {
    scrollToTop();
    getReviewDetails();
    getPeerRating();
    getAveragePeerRating();
    getCandidateExperiences();

    console.log(
      "from wizard " +
        StorageService.getFromSessionStorage(StorageValues.isFromWizard)
    );
  }, []);

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handlePreferContact = (event) => {
    setPreferredContactType(event.target.value);
    if (event.target.value == "") {
      setPreferedEmail(false);
      setPeerContactNumber("");
      setPreferedContactNumber(false);
    } else if (event.target.value == "Email") {
      setPreferedEmail(true);
      setPeerContactNumber("");
      setPreferedContactNumber(false);
    } else if (event.target.value == "phoneNumber") {
      setPreferedContactNumber(true);
      setPreferedEmail(false);

      setPeerContactNumber("");
      setInputField((prevState) => ({
        ...prevState,
        email: "",
      }));
    } else {
      setPreferedEmail(false);
      setPreferedContactNumber(false);
      setInputField((prevState) => ({
        ...prevState,
        email: "",
      }));
    }
  };

  const getCandidateExperiences = () => {
    ProfileService.getExperience().then((response) => {
      try {
        var experienceDetails = response.data;
        if (experienceDetails !== null) {
          if (experienceDetails.exps != null) {
            var explist = [...experiencesList];
            response.data.exps.length > 0 &&
              response.data.exps.map((experience) => {
                const obj = {
                  key: experience.id,
                  value: experience.employer,
                };
                explist.push(obj);
              });
          }
          setExperiencesList(explist);
        }
      } catch (err) {
        console.error("getExperience" + JSON.stringify(err));
      }
    });
  };

  // const sendPeerRequest = (event) => {
  //   setShowButton(false);
  //    checkSkills();
  // };

  const getReviewDetails = () => {
    const peerReqStatus = "";
    ProfileService.getRatingReview(peerReqStatus).then((response) => {
      try {
        var peerRatingDetails = response.data;
        if (peerRatingDetails != null) {
          if (peerRatingDetails.reqList.length > 0) {
            setPeerRatingList(peerRatingDetails.reqList);
          }
        }
      } catch (err) {
        console.error("getRatingReview" + JSON.stringify(err));
      }
    });
  };

  const showPeerEmailOrNumber = (peerReq) => {
    if (peerReq.email) {
      return "Email: " + peerReq.email;
    }
    if (peerReq.contactNumber) {
      var phoneNumberPeer = peerReq.contactNumber;
      return "Text: " + formattedMobileNumber(phoneNumberPeer);
    }
  };

  const resendRequest = (resendId) => {
    ProfileService.resendRequestService(resendId).then((response) => {
      try {
        Stringutility.showSuccessMessage(Constants.requestResentSuccessfully);
      } catch (err) {
        console.error("resendRequestService" + JSON.stringify(err));
      }
    });
  };
  const handleSelectionChange = (e) => {
    setSelectionId(e.target.value);
    if (e.target.value == "personal") {
      setShowPersonal(true);
      setPersonalRelation(true);
      setShowEmployers(false);
      setExpId("");
    } else if (e.target.value == "") {
      setShowPersonal(false);
      setShowEmployers(false);
      setExpId("");
    } else {
      setShowPersonal(true);
      setShowEmployers(true);
      setExpId(e.target.value);
    }
  };

  const goToDashboard = () => {
    StorageService.removeItemInLocalStorage(StorageValues.isFromWizard);
    history.push("/dashboard");
  };

  const navigate = () => {
    if (Stringutility.isNullOrEmpty(inputField.firstName)) {
      Stringutility.showErrorMessage(Constants.enterFirstName);
      return;
    }

    if (Stringutility.isNullOrEmpty(inputField.lastName)) {
      Stringutility.showErrorMessage(Constants.enterLastName);
      return;
    }
    if (!ispreferedEmail && !ispreferedContactNumber) {
      Stringutility.showErrorMessage(Constants.selectPreferredContactType);
      return;
    }

    let _mobileNumber = "";
    if (ispreferedEmail) {
      if (Stringutility.isNullOrEmpty(inputField.email)) {
        Stringutility.showErrorMessage(Constants.enterEmail);
        return;
      } else if (!isValidEmail(inputField.email)) {
        Stringutility.showErrorMessage(Constants.enterValidEmail);
        return;
      }
    } else {
      if (Stringutility.isNullOrEmpty(peerContactNumber)) {
        Stringutility.showErrorMessage(Constants.enterPhoneNumber);
        return;
      } else {
        if (!Stringutility.isNullOrEmpty(peerMobileNumber)) {
          if (
            !validatePhoneNumber(
              peerMobileNumber,
              "+" + peerMobileNumberCountryCode
            )
          ) {
            Stringutility.showErrorMessage(Constants.enterValidPhoneNumber);
            return;
          } else {
            _mobileNumber =
              peerMobileNumberCountryCode + "-" + peerMobileNumber;
          }
        } else {
          Stringutility.showErrorMessage(Constants.enterPhoneNumber);
          return;
        }
      }
    }
    // setShowButton(false);
    checkSkills();
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const showOrHide = () => {
    setShowRatings(!showRatings);
  };
  const peerContactHandleChange = (value, country) => {
    setPeerContactNumber(value);

    if (country != null) {
      let dialCode = country.dialCode;
      let countryCode = country.countryCode;
      let dialCodeLength = dialCode.length;
      let number = value.slice(dialCodeLength).replace(/\D/g, "");
      let mobileNumber = getPhoneNumberByCountryCode(number, countryCode);
      setPeerMobileNumberCountryCode(dialCode);
      setPeerMoblieNumber(mobileNumber);
    }
  };

  const getPeerRating = () => {
    ProfileService.getRating().then((response) => {
      try {
        var peerRatinhDetails = response.data;
        if (peerRatinhDetails != null) {
          setRatingCount(response.data.size);
          if (peerRatinhDetails.reqList != null) {
            if (peerRatinhDetails.reqList.length > 0) {
              peerRatinhDetails.reqList.map((peerReqId) => {
                setPeerRatingId(peerReqId.shortId);
              });
            }
          }
        }
      } catch (err) {
        console.error("getRating" + JSON.stringify(err));
      }
    });
  };
  const peerCount = () => {
    if (peerRatingList.length == 0) {
      return 1;
    } else {
      return peerRatingList.length + 1;
    }
  };

  const getAveragePeerRating = () => {
    ProfileService.getAveragePeerratingService().then((response) => {
      try {
        var peerAvg = response.data;
        if (peerAvg !== null) {
          if (peerAvg.skillsRating.skills != null) {
            setavgrating(peerAvg.skillsRating.skills);
          }
        }
      } catch (err) {
        console.error("getAveragePeerratingService" + JSON.stringify(err));
      }
    });
  };

  const checkSkills = () => {
    JobService.skillVerification().then((response) => {
      try {
        var skillDetails = response.data;
        if (skillDetails != null) {
          var isSkilled = skillDetails.skilled;
          if (skillDetails.skilled) {
            sendPeerRating();
          } else {
            Stringutility.showErrorMessage(
              Constants.skillsNotAddedIntoYourProfile
            );
          }
        }
      } catch (err) {
        console.error("skillVerification" + JSON.stringify(err));
      }
    });
  };

  const sendPeerRating = () => {
    let peerContact = "";
    if (!Stringutility.isNullOrEmpty(peerMobileNumber)) {
      if (
        !validatePhoneNumber(
          peerMobileNumber,
          "+" + peerMobileNumberCountryCode
        )
      ) {
        Stringutility.showErrorMessage(Constants.enterValidPhoneNumber);
        return;
      } else {
        peerContact = peerMobileNumberCountryCode + "-" + peerMobileNumber;
      }
    }

    const peerRequest = {
      firstName: inputField.firstName,
      lastName: inputField.lastName,
      email: inputField.email,
      contactNumber: peerContact,
      workedSameTeam: workedSameTeam,
      youSupervisedPeer: youSupervisedPeer,
      b2bRelation: b2bRelation,
      customerRelation: customerRelation,
      workedDiffTeams: workedDiffTeams,
      peerSupervisedYou: peerSupervisedYou,
      mentoringOrTraining: mentoringOrTraining,
      academicRelation: academicRelation,
      personalMessage: inputField.description,
      personalRelation: personalRelation,
      experienceId: expId,
    };

    if (requestId == "") {
      setpeerRewquestEnabled(true);
      ProfileService.addPeerRating(peerRequest).then((response) => {
        setpeerRewquestEnabled(false);
        try {
          Stringutility.showSuccessMessage(
            Constants.peerRequestAddedSuccessfully
          );

          setInputField((prevState) => ({
            ...prevState,
            firstName: "",
            lastName: "",
            email: "",
          }));
          setExpId("");
          clearDetails();
          setPeerContactNumber("");
          setPreferedEmail(false);
          setPreferedContactNumber(false);

          setPreferedEmail(false);
          setPeerContactNumber("");
          setPreferedContactNumber(false);
          setPreferredContactType("");

          getReviewDetails();
        } catch (err) {
          console.error("addPeerRating" + JSON.stringify(err));
        }
      });
    } else {
      ProfileService.updatePeerRating(peerRequest, requestId).then(
        (response) => {
          try {
            Stringutility.showSuccessMessage(
              Constants.peerRequestUpdatedSuccessfully
            );
            setInputField((prevState) => ({
              ...prevState,
              firstName: "",
              lastName: "",
              email: "",
            }));
            clearDetails();
            setExpId("");
            setPeerContactNumber("");
            setPreferedEmail(false);
            setPreferedContactNumber(false);

            setPreferedEmail(false);
            setPeerContactNumber("");
            setPreferedContactNumber(false);
            setPreferredContactType("");

            getReviewDetails();
          } catch (err) {
            console.error("updatePeerRating" + JSON.stringify(err));
          }
        }
      );
    }
  };
  const scrollToTop = () => {
    const element = document.getElementById("scrollToTop");
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
  };

  const accordionHeader = document.querySelectorAll(".accordion-header");
  accordionHeader.forEach((header) => {
    header.addEventListener("click", function () {
      const accordionContent =
        header.parentElement.querySelector(".accordion-content");
      let accordionMaxHeight = accordionContent.style.maxHeight;

      // Condition handling
      if (accordionMaxHeight == "0px" || accordionMaxHeight.length == 0) {
        accordionContent.style.maxHeight = `${
          accordionContent.scrollHeight + 32
        }px`;
        header.querySelector(".skillsToggle").classList.remove("rotate-0");
        header.querySelector(".skillsToggle").classList.add("rotate-180");
        header.parentElement.classList.add("shadow-lg");
      } else {
        accordionContent.style.maxHeight = `0px`;
        header.querySelector(".skillsToggle").classList.add("rotate-0");
        header.querySelector(".skillsToggle").classList.remove("rotate-180");
        header.parentElement.classList.remove("shadow-lg");
      }
    });
  });

  function toggleText() {
    var dots = document.getElementById("dots");
    var moreText = document.getElementById("more");
    var p = document.getElementById("button");

    if (dots.classList.contains("hidden")) {
      // Show the dots
      dots.classList.remove("hidden");

      // Hide the more text
      moreText.classList.add("hidden");

      // change text of the button
      p.innerHTML = "Learn more";
    } else {
      // Hide the dots
      dots.classList.add("hidden");

      // hide the more text
      moreText.classList.remove("hidden");

      // change text of the button
      p.innerHTML = " Hide";
    }
  }

  return (
    <div
      className="
     grid max-md:gap-12 min-md:gap-8 min-xl:gap-12 
     max-md:grid-cols-1 min-md:grid-cols-5 min-lg:grid-cols-5 min-2xl:grid-cols-3 min-md:absolute 
     min-md:ml-48 min-xl:ml-52 min-md:top-24
     min-md:min-w-[70%] min-lg:min-w-[80%] min-md:pr-[3%] t-smart-left-top-pad"
    >
      <header className=" bg-gradient-to-br from-primary-blue3 to-primary-blue min-md:fixed top-0 w-screen max-md:h-[160px] max-md:-z-10 min-md:z-0 min-md:h-16 shadow-primary-gray p-0 "></header>

      <div
        className=" min-md:col-span-3 min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full
                    order-1"
      >
        <h1 className="peertTitle text-2xl text-primary-dark font-bold mb-4 max-md:pl-4 max-md:-mt-[180px] max-md:text-primary-white">
          My Peers
        </h1>

        <div className="peerRatings-container ">
          <div className="relative min-md:p-7 max-md:py-4 max-md:px-7 max-md:mx-4 bg-gradient-to-r from-primary-white via-primary-white to-primary-white shadow-md rounded-xl ">
            <div className=" text-xl text-primary-dark pb-2 font-bold">
              Be a trusted candidate
            </div>
            <div className="text-primary-dark min-lg:w-1/2 min-xl:w-3/5 ">
              <TrustedCandidateText />
              <span
                className="inline text-primary-blue cursor-pointer"
                onClick={() => toggleText()}
                id="button"
              >
                Learn more
              </span>
            </div>

            <div
              className="candidateGraphic 
                                max-md:mt-4 min-lg:w-[40%] min-2xl:w-[35%]
                                min-lg:absolute min-lg:right-0 min-2xl:-right-2 
                                bottom-0 z-0"
            >
              <SvgRatingSkillCandidate />
            </div>
          </div>
        </div>
      </div>

      <div
        className="graphic_wrapper 
                    order-2 
                    min-md:row-start-1 min-md:col-start-4 min-lg:col-start-4 min-2xl:col-start-3
                    min-md:col-span-2 min-lg:col-span-2 min-2xl:col-span-1 max-md:col-span-full
                    max-md:px-4"
      >
        <h1
          className="peertTitle 
                    text-2xl text-primary-dark font-bold mb-4 max-md:pl-4 max-md:-mt-[100px] 
                    max-md:text-primary-white max-md:hidden"
        >
          &nbsp;
        </h1>
        <div className="relative bg-primary-white p-7 rounded-2xl shadow-lg">
          <div className="myPeersGraphic absolute right-[10%] max-md:-top-4 min-md:-top-7 min-xl:-top-12 w-[30%] drop-shadow-md z-10">
            <SvgRatingImage />
          </div>
          <div className="text-xl text-primary-dark font-bold ">My Peers</div>
          <div className="flex flex-row gap-4 items-baseline">
            <div className=" font-semibold text-5xl text-primary-blue">
              {ratingCount}
            </div>
          </div>

          <div className="transition duration-300 ease-in-out">
            <div className="accordion-header cursor-pointer transition flex space-x-5 px-5 items-center">
              <div className="skillsToggle -mt-9 ml-5 rotate-0 transition duration-200 ease-in-out">
                {ratingCount >= 3 ? (
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={showOrHide}
                  >
                    <circle
                      className="hover:shadow-inner focus:shadow-inner"
                      cx="10"
                      cy="10"
                      r="10"
                      transform="rotate(-180 10 10)"
                      fill="#1F9DFC"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6.65403 8.52903C6.77607 8.40699 6.97393 8.40699 7.09597 8.52903L10 11.4331L12.904 8.52903C13.0261 8.40699 13.2239 8.40699 13.346 8.52903C13.468 8.65107 13.468 8.84893 13.346 8.97097L10.221 12.096C10.0989 12.218 9.90107 12.218 9.77903 12.096L6.65403 8.97097C6.53199 8.84893 6.53199 8.65107 6.65403 8.52903Z"
                      fill="white"
                      stroke="white"
                      strokeWidth="0.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <></>
                )}
              </div>
            </div>

            <div
              className="accordion-content overflow-hidden max-h-0 
                                absolute left-0 bg-primary-white px-7 pb-4 rounded-xl
                                w-full transition duration-200 ease-in-out
                                "
            >
              <div className="text-lg text-primary-dark font-bold mt-4">
                My peer rated skills
              </div>

              <div className="grid grid-cols-2 gap-3 items-center font-normal text-sm mt-2">
                {avgrating.length > 0 &&
                  avgrating.map((skillsRating, index) => {
                    return (
                      <div
                        key={index}
                        className="basis-[48%] py-3 text-center bg-primary-gray rounded-xl "
                      >
                        <div className="">{skillsRating.name}</div>
                        <div className="text-center items-center justify-center inline-block my-2">
                          <Card className="star_bg_color col-12 t-ipad-pad">
                            <ReactStars
                              count={5}
                              edit={false}
                              size={16}
                              value={skillsRating.rating}
                              id={skillsRating.skillId + "_rating"}
                              activeColor="rgb(255, 188, 59)"
                            ></ReactStars>
                          </Card>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="askpeers_wrapper 
                    order-3
                    min-md:col-span-3 min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full 
                    max-md:px-7 max-md:mt-4 "
      >
        <div className="">
          <div className="font-bold text-2xl text-primary-dark pb-4">
            Teamanics is massively scaling the personal referral
          </div>
          <div className="min-md:bg-white min-md:shadow-lg min-md:rounded-2xl min-md:border min-md:px-6 min-md:py-8 w-full">
            <div className="min-md:w-3/4 font-normal text-xs mb-7 min-md:text-sm ">
              Enter your peer information below. We will send them rating
              requests.{" "}
            </div>

            <div className="  ">
              <div className="basicInfo_wrapper">
                <p>
                  <strong>Peer {peerCount()}</strong>
                </p>
                <div className="rounded-lg w-full">
                  {/* <div className="min-xl:w-1/2"> */}
                  <div className="flex flex-wrap gap-y-5">
                    <div className="flex flex-row t-width-input max-sm:flex-col max-sm:gap-1 t-gap1-input-peer max-sm:items-start gap-7 w-full items-center">
                      <label
                        htmlFor="firstname"
                        className="form-label basis-1/3"
                      >
                        First Name*
                      </label>
                      <div className="w-full">
                        <div className="text-xs text-[#B50000] -mt-4 absolute bg-primary-white h-[20px] w-auto p-1 max-sm:right-[30px] hidden">
                          *First Name cannot be empty
                        </div>

                        <input
                          type="text"
                          className="t-input-field-pad  t-rounded-lg form-control w-full px-3 py-2 text-sm font-normal text-Gray-600 bg-white bg-clip-padding border border-solid border-primary-gray2 rounded-lg transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none t-form-control"
                          value={inputField.firstName}
                          name="firstName"
                          onChange={inputsHandler}
                          id="typeText"
                          placeholder="First Name *"
                        />
                      </div>
                    </div>
                    <div className="flex flex-row max-sm:flex-col t-width-input max-sm:gap-1 max-sm:items-start t-gap1-input-peer gap-7 w-full items-center">
                      <label
                        htmlFor="lasttname"
                        className="form-label basis-1/3"
                      >
                        Last Name*
                      </label>
                      <div className="w-full">
                        <div className="text-xs text-[#B50000] -mt-4 absolute bg-primary-white h-[20px] w-auto p-1 max-sm:right-[30px] hidden">
                          *Last Name cannot be empty
                        </div>
                        <input
                          type="text"
                          name="lastName"
                          onChange={inputsHandler}
                          value={inputField.lastName}
                          className="t-input-field-pad t-rounded-lg form-control w-full px-3 py-2 text-sm font-normal text-Gray-600 bg-white bg-clip-padding border border-solid border-primary-gray2 rounded-lg transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none t-form-control"
                          id="typeText"
                          placeholder="Last Name *"
                        />
                      </div>
                    </div>
                    <div className="flex flex-row max-sm:flex-col t-width-input max-sm:gap-1 max-sm:items-start t-gap1-input-peer gap-7 w-full items-center">
                      <label htmlFor="email" className="form-label basis-1/3">
                        {" "}
                        Contact Type*
                      </label>
                      <div className="w-full">
                        <select
                          value={preferredContactType}
                          onChange={handlePreferContact}
                          className="t-input-field-pad t-rounded-lg form-control w-full px-3 py-2 text-sm font-normal text-Gray-600 bg-white bg-clip-padding border border-solid border-primary-gray2 rounded-lg transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none t-form-control"
                        >
                          <option value=""> Preferred Contact Type</option>
                          <option value="Email">Email</option>
                          <option value="phoneNumber">Text</option>
                        </select>
                      </div>
                    </div>
                    <div className="flex flex-row max-sm:flex-col t-width-input max-sm:gap-1 max-sm:items-start t-gap1-input-peer gap-7 w-full items-center">
                      {ispreferedEmail ? (
                        <>
                          {" "}
                          <label
                            htmlFor="email"
                            className="form-label basis-1/3"
                          >
                            Email*
                          </label>
                        </>
                      ) : (
                        <></>
                      )}
                      {ispreferedContactNumber ? (
                        <label htmlFor="email" className="form-label basis-1/3">
                          Contact Number*
                        </label>
                      ) : (
                        <></>
                      )}
                      <div className="w-full">
                        {ispreferedEmail ? (
                          <>
                            {/* <label htmlFor="email" className="form-label basis-1/3"> Email </label> */}
                            <input
                              type="text"
                              name="email"
                              onChange={inputsHandler}
                              value={inputField.email}
                              className=" t-input-field-pad t-rounded-lg form-control w-full px-3 py-2 text-sm font-normal text-Gray-600 bg-white bg-clip-padding border border-solid border-primary-gray2 rounded-lg transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none t-form-control mb-3"
                              id="typeText"
                              placeholder=" Email *"
                            />
                          </>
                        ) : (
                          <></>
                        )}
                        {ispreferedContactNumber ? (
                          <div className="mb-3 input-group">
                            <div className="input-group-prepend"></div>
                            <PhoneInput
                              country="us"
                              countryCodeEditable={false}
                              className="t-rounded-lg t-form-control"
                              type="text"
                              name="peerContactNumber"
                              data-testid="candidateprofile-peerContactNumber"
                              onChange={peerContactHandleChange}
                              value={peerContactNumber}
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="relationship">
                    <div className="flex flex-row max-sm:flex-col t-width-input max-sm:gap-1 max-sm:items-start t-gap1-input-peer gap-7 w-full items-center">
                      <label className="form-label basis-1/3">
                        How do you know this person?
                      </label>

                      <div className="w-full">
                        <select
                          // className="form-select w-full px-3 py-2 text-sm font-normal text-primary-dark bg-white bg-clip-padding border border-solid border-primary-gray2 rounded-lg min-sm:w-1/2 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none px-5 pad-2 rounded-card"
                          className="t-padding t-input-field-pad t-rounded-lg form-control w-full px-3 py-2 text-sm font-normal text-Gray-600 bg-white bg-clip-padding border border-solid border-primary-gray2 rounded-lg transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none t-form-control"
                          id="experince_list"
                          name=""
                          form=""
                          value={expId}
                          onChange={handleSelectionChange}
                        >
                          <option value="">Please select Job Experience</option>
                          {experiencesList.length > 0 &&
                            experiencesList.map(({ value, key }) => (
                              <option value={key} key={"value" + key}>
                                {value}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  {showEmployers && (
                    <div className="w-full bg-white shadow rounded-xl p-6 my-6 shd_peer">
                      <h4 className="font-bold text-sm">
                        Please verify your relationship. Check all that apply.
                      </h4>
                      <div className=" font-normal text-sm my-3">
                        <ul className="px-5">
                          <li className="my-2">
                            <label
                              className="form-check-label"
                              htmlFor="workedInSameTeam"
                            >
                              <input
                                className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                                type="checkbox"
                                id="workedInSameTeam"
                                checked={workedSameTeam}
                                onChange={updateWorkedSameTeam}
                              />
                              Worked in the same team
                            </label>
                          </li>
                          <li>
                            <label
                              className="form-check-label"
                              htmlFor="youSupervised"
                            >
                              <input
                                className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                                type="checkbox"
                                id="youSupervised"
                                checked={youSupervisedPeer}
                                onChange={updateYouSupervisedPeer}
                              />
                              You supervised{" "}
                              {capitalizeFirst(inputField.firstName)}
                            </label>
                          </li>
                          <li className="my-2">
                            <label
                              className="form-check-label"
                              htmlFor="supervisedYou"
                            >
                              <input
                                className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                                type="checkbox"
                                id="supervisedYou"
                                checked={peerSupervisedYou}
                                onChange={updatePeerSupervisedYou}
                              />
                              {capitalizeFirst(inputField.firstName)} supervised
                              you
                            </label>
                          </li>
                          <li className="my-2">
                            <label
                              className="form-check-label"
                              htmlFor="b2bRelationship"
                            >
                              <input
                                className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                                type="checkbox"
                                id="b2bRelationship"
                                checked={b2bRelation}
                                onChange={updateB2BRelation}
                              />
                              Business to business relationship
                            </label>
                          </li>
                          <li className="my-2">
                            <label
                              className="form-check-label"
                              htmlFor="mentoringRelationship"
                            >
                              <input
                                className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                                type="checkbox"
                                id="mentoringRelationship"
                                checked={mentoringOrTraining}
                                onChange={updateMentoringOrTraining}
                              />
                              Mentoring or training relationship
                            </label>
                          </li>
                          <li className="my-2">
                            <label
                              className="form-check-label"
                              htmlFor="customerRelationship"
                            >
                              <input
                                className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                                type="checkbox"
                                id="customerRelationship"
                                checked={customerRelation}
                                onChange={updateCustomerRelation}
                              />
                              Customer relationship
                            </label>
                          </li>
                          <li className="my-2">
                            <label
                              className="form-check-label"
                              htmlFor="academicRelationship"
                            >
                              <input
                                className="form-check-input appearance-none h-3 w-3 mt-1 align-top mr-2 border border-Gray-500 bg-white checked:bg-primary-blue checked:border-primary-white focus:outline-none transition duration-200 cursor-pointer border_color_peer"
                                type="checkbox"
                                id="academicRelationship"
                                checked={academicRelation}
                                onChange={updateAcademicRelation}
                              />
                              Academic relationship
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}

                  <div className="max-sm:flex max-sm:flex-wrap mt-2">
                    <div className="basis-full continue-button  inline">
                      <TeamanicsButton
                        className="mt-3"
                        onClick={navigate}
                        disabled={peerRewquestEnabled}
                      >
                        Send
                      </TeamanicsButton>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {!Stringutility.isNullOrEmpty(
          StorageService.getFromLocalStorage(StorageValues.isFromWizard)
        ) &&
          StorageService.getFromLocalStorage(StorageValues.isFromWizard) && (
            <TeamanicsButton
              className=" mt-3"
              title="Go to My Dashboard"
              onClick={goToDashboard}
            >
              Done. Go to My Dashboard
            </TeamanicsButton>
          )} */}
      </div>

      <div
        className="myratingsrequests_wrapper 
                    order-4
                    min-md:row-start-2 min-md:col-start-4 min-lg:col-start-4 min-2xl:col-start-3
                    min-md:col-span-2 min-lg:col-span-2 min-2xl:col-span-1 max-md:col-span-full 
                    "
      >
        <div className="ratingsrequests max-md:px-7 max-md:mb-12">
          {peerRatingList.length > 0 && (
            <h2 className="font-bold text-2xl pb-4">My rating requests</h2>
          )}

          <div className="ratingsrequests_wrapper max-md:pb-4 min-md:overflow-y-scroll min-md:max-h-[400px] min-md:pr-4 max-md:w-[100%] max-md:overflow-hidden max-md:overflow-x-scroll scrollbar-thin scrollbar-thumb-rounded-md scrollbar-thumb-Blue-600 scrollbar-track-Gray-200">
            <div className="ratingsrequests flex min-md:flex-col max-md:flex-row max-md:nowrap gap-4">
              {peerRatingList.length > 0 &&
                peerRatingList.map((peerRequest, index) => {
                  const start_date = new Date(
                    peerRequest.createdOn
                  ).toDateString();
                  return (
                    <div
                      className="flex flex-col gap-2 px-7 py-6 min-w-[300px] shadow rounded-xl  bg-primary-white"
                      key={index}
                    >
                      <div className="font-bold text-lg text-primary-blue">
                        {peerRequest.firstName + " " + peerRequest.lastName}
                      </div>
                      <div className="font-normal text-sm ">
                        {showPeerEmailOrNumber(peerRequest)}
                      </div>
                      {/* <div className="font-normal text-sm">
                        <span >
                          Request sent {timeDifference(peerRequest.createdOn)}{' '}
                        </span>
                      </div> */}

                      <div className="flex ">
                        <div className="text-center font-semibold text-sm bg-slate-200 rounded px-3 py-1 t-peer-sent-card max-w-2xl">
                          <svg
                            className="inline mr-1"
                            width="8"
                            height="8"
                            viewBox="0 0 8 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="4" cy="4" r="4" fill="#1F9DFC" />
                          </svg>
                          {peerRequest.reqStatus.value}
                        </div>
                        <div>
                          {peerRequest.reqStatus.value !=
                            "Reviewed by peer" && (
                            <div className="ml-3">
                              <button
                                className="text-center font-semibold text-sm bg-slate-200 rounded px-3 py-1  max-w-2xl"
                                onClick={(e) => resendRequest(peerRequest.id)}
                              >
                                Resend
                              </button>{" "}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="font-normal text-sm">
                        <span>{timeDifference(peerRequest.createdOn)} </span>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatingScreen;